import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext'; // AuthContext'i import et
import { auth } from '../firebase'; 
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider'; // Divider ekleyelim
import GoogleIcon from '@mui/icons-material/Google'; // Google ikonu

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false); // Google girişi için ayrı loading state'i
  const navigate = useNavigate();
  const { signInWithGoogle } = useAuth(); // signInWithGoogle fonksiyonunu AuthContext'ten al

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log('User logged in successfully:', userCredential.user);
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      let friendlyErrorMessage = "Giriş sırasında bir hata oluştu.";
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        friendlyErrorMessage = "E-posta veya şifre hatalı.";
      } else if (err.code === 'auth/invalid-email') {
        friendlyErrorMessage = "Geçersiz e-posta formatı.";
      }
      setError(friendlyErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError(null);
    setGoogleLoading(true);
    try {
      await signInWithGoogle();
      console.log('User logged in successfully with Google');
      navigate('/dashboard'); // Başarılı giriş sonrası dashboard'a yönlendir
    } catch (err) {
      console.error('Google Login error:', err);
      let friendlyErrorMessage = "Google ile giriş sırasında bir hata oluştu.";
      // Firebase'den dönebilecek spesifik Google hata kodları burada işlenebilir
      // Örneğin: err.code === 'auth/popup-closed-by-user'
      setError(friendlyErrorMessage);
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 3,
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Typography component="h1" variant="h5">
          Admin Panel Girişi
        </Typography>
        <Box component="form" onSubmit={handleLogin} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="E-posta Adresi"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Şifre"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          {error && (
            <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
              {error}
            </Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Giriş Yap'}
          </Button>
          <Divider sx={{ my: 2 }}>VEYA</Divider>
          <Button
            type="button" // Form submit etmemesi için type="button"
            fullWidth
            variant="outlined" // Farklı bir stil için outlined
            sx={{ mt: 1, mb: 2 }}
            onClick={handleGoogleLogin}
            disabled={googleLoading} // Google girişi sırasında butonu disable et
            startIcon={<GoogleIcon />}
          >
            {googleLoading ? <CircularProgress size={24} color="inherit" /> : 'Google ile Giriş Yap'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default LoginPage;
